import Alert from '@mui/material/Alert'
import I18n from 'i18n-js'
import { PropTypes } from 'prop-types'
import queryString from 'query-string'
import { PureComponent } from 'react'

import { connect, selectors, actions } from '../../../stores'
import AuthCard from '../AuthCard'
import AuthCardHeader from '../AuthCardHeader'
import AuthPageLayout from '../AuthPageLayout'

import ForgotPasswordConfirmation from './ForgotPasswordConfirmation'
import ForgotPasswordForm from './ForgotPasswordForm'

export class ForgotPasswordView extends PureComponent {
  componentWillUnmount() {
    this.props.hideConfirmation()
  }
  renderForgotPassword() {
    if (this.props.showForgotPasswordConfirmation) {
      return <ForgotPasswordConfirmation />
    } else {
      return <ForgotPasswordForm />
    }
  }
  render() {
    const params = queryString.parse(window.location.search)

    return (
      <AuthPageLayout>
        <AuthCard>
          <AuthCardHeader header={I18n.t('auth.promoboxxLogin')} />
          {params.expired === 'true' && (
            <Alert severity="warning">
              {I18n.t('auth.forgotPasswordTokenInvalid')}
            </Alert>
          )}
          {this.renderForgotPassword()}
        </AuthCard>
      </AuthPageLayout>
    )
  }
}

ForgotPasswordView.propTypes = {
  hideConfirmation: PropTypes.func,
  showForgotPasswordConfirmation: PropTypes.bool,
}

export default connect(
  (state) => ({
    ...selectors.forgotPassword.selectShowForgotPasswordConfirmation(state),
  }),
  {
    hideConfirmation: actions.forgotPassword.hideForgotPasswordConfirmation,
  },
)(ForgotPasswordView)
